var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",staticStyle:{"{\n      'background-color'":"mycolors.background"}},[_c('AppBar'),_c('AppBody')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }